module.exports = __webpack_public_path__ + "img/er.4fafcb3c.svg";